import {requestContext} from '../../../../common/requestContext';
import {twMerge} from '../../../../common/twMerge';
import {ScrollableHorizontalList} from '../../../../design-system/molecules/ScrollableHorizontalList/ScrollableHorizontalList';
import {CommonGroupProps} from '../../type';

export function HorizontalScroll({children}: CommonGroupProps) {
  const isMobile = requestContext.requestInfo.display.isMobile;
  return (
    <ScrollableHorizontalList
      isMobile={isMobile}
      gapPx={4}
      // HorizontalScroll 요소는 섹션기준으로 정렬되기 때문에 static으로 position을 해제합니다.
      className={twMerge(
        'static',
        !isMobile && 'px-11pxr' // PC 판형 가로스크롤 섹션에는 우측 패딩이 들어갑니다
      )}
      innerLeftPx={isMobile ? 11 : 0}
      innerRightPx={isMobile ? 11 : 0}
    >
      {children}
    </ScrollableHorizontalList>
  );
}
